import type { FieldValues } from 'react-hook-form';
import type { DefaultValues } from 'react-hook-form';
import { DynamicForm } from '../DynamicForm';
import { useDataManagementContext } from '../../../hooks/useDataManagementContext';
import { useRelatedDataWithContext } from '../../../hooks/useRelatedDataWithContext';
import { Logger } from '@shared/logger';

export function DataManagementForm<TData extends FieldValues>() {
  const { 
    mappings, 
    schema, 
    selectedItem, 
    onSubmit, 
    onOpenChange 
  } = useDataManagementContext<TData>();
  const logger = new Logger();

  // Fetch related data for the form
  const { relatedData, isLoading: relatedDataLoading, error: relatedDataError } = useRelatedDataWithContext(mappings);

  // Show error if related data failed to load
  if (relatedDataError) {
    logger.warn('Related data loading error in form', 'data.users', undefined, { error: relatedDataError });
  }

  return (
    <DynamicForm<TData>
      mappings={mappings}
      schema={schema}
      defaultValues={selectedItem as DefaultValues<TData> || undefined}
      onSubmit={async (data) => {
        try {
          await onSubmit(data);
          onOpenChange(false);
        } catch (error) {
          logger.error('Error in form submission', 'data.users', undefined, error as Error);
          throw error;
        }
      }}
      isEdit={!!selectedItem}
      onCancel={() => onOpenChange(false)}
      relatedData={relatedData}
      isLoading={relatedDataLoading}
    />
  );
} 